import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { Stroke, Style } from 'ol/style';
import store from '../../store';
import { setSelection } from '../../reducers/mainControls';
import { levelConfig } from '../../config/level-config';
import { zoomToExtent } from './mapHelpers';
import { openPopup } from './popup';

const source = new VectorSource({ features: [] });
const style = new Style({
  stroke: new Stroke({
    color: 'rgba(255, 255, 0, 1)',
    width: 2,
  }),
});
const selectionLayer = new VectorLayer({ source, style });

export const selectAddressPoint = async ({ id, addressType }) => {
  const { cacheVersion } = store.getState();
  const res = await fetch(`/api/feature/${addressType}/${id}?v=${cacheVersion}`);
  const data = await res.json();
  openPopup({
    coordinate: data.feature.geometry.coordinates,
    content: {
      address: data.feature.properties.address,
      service_coverage: data.feature.properties.service_coverage,
      town: data.feature.properties.town,
    },
  });
};

export const selectMapGeom = async ({ table, id, zoomTo }) => {
  const { cacheVersion } = store.getState();
  const res = await fetch(`/api/feature/${table}/${id}?v=${cacheVersion}`);

  const geojson = (await res.json()).feature;
  const { level } = store.getState().mainControls;
  store.dispatch(setSelection({ ...geojson.properties, level }));

  const feature = new GeoJSON().readFeature(geojson);
  source.clear();
  source.addFeature(feature);
  if (zoomTo) {
    const extent = feature.getGeometry().getExtent();
    zoomToExtent(extent);
  }
};

export const addSelectionLayerToMap = (map) => {
  map.addLayer(selectionLayer);

  map.on('click', async (evt) => {
    let updated = false;
    let clickedAddressPoint = false;

    map.forEachFeatureAtPixel(evt.pixel, (f, layer) => {
      if (!clickedAddressPoint && layer.mbi && layer.mbi.title?.includes('Locations')) {
        const { id, service_coverage } = f.getProperties();
        let addressType;
        switch (service_coverage) {
          case 'Served':
            addressType = 'location_served';
            break;
          case 'Unserved':
            addressType = 'location_underserved';
            break;
          default:
            addressType = 'location_underserved';
            break;
        }
        clickedAddressPoint = true;
        selectAddressPoint({ id, addressType });
      }
      if (!updated && layer.mbi && layer.mbi.level) {
        const { id } = f.getProperties();
        const { table } = levelConfig[layer.mbi.level];
        updated = true;
        selectMapGeom({ id, table });
      }
    });

    if (!updated) {
      store.dispatch(setSelection(null));
      source.clear();
    }
  });
};
